export default __webpack_public_path__ + "static/media/bear.6f85fd76.svg";